import { Card } from '../../SharedComponents/Card'
import { DataTable } from './DataTable'
import { formatCurrency, formatNegative } from '../../../lib/utils/format'
import type {
  ClawbackBreakdownCardProps,
  ClawbackBreakdownRow,
  Column,
} from '../types'
import styles from '../index.module.css'

const columns: Column<ClawbackBreakdownRow>[] = [
  { title: 'Month', key: 'month', accessor: 'month' },
  {
    title: 'Paid Units',
    key: 'paid_units',
    accessor: 'paid_units',
  },
  {
    title: 'Total Debt Paid',
    key: 'total_debt_paid',
    render: (r) => formatCurrency(r.total_debt_paid),
  },
  {
    title: 'BPS',
    key: 'bps',
    accessor: 'bps',
  },
  {
    title: 'Unit Bonus',
    key: 'unit_bonus',
    render: (r) => formatCurrency(r.unit_bonus),
  },
  {
    title: 'Clawback (#)',
    key: 'clawbacks',
    accessor: 'clawbacks',
  },
  {
    title: 'Clawback ($)',
    key: 'clawback_value',
    render: (r) => formatNegative(r.clawback_value),
  },
  {
    title: 'Total Clawback (#)',
    key: 'total_clawbacks',
    accessor: 'total_clawbacks',
  },
  {
    title: 'Total Clawback ($)',
    key: 'total_clawback_value',
    render: (r) => formatNegative(r.total_clawback_value),
  },
]

export default function ClawbackBreakdownCard({
  rows,
  loading,
}: ClawbackBreakdownCardProps) {
  const total = rows[rows.length - 1]
  const summary =
    total &&
    columns.map((c) =>
      c.render ? c.render(total) : String(total[c.accessor!] ?? ''),
    )

  return (
    <Card>
      <div className={styles.cardHeader}>Clawback Breakdown</div>
      <DataTable
        columns={columns}
        data={rows.slice(0, -1)}
        rowKey={(_r, i) => String(i)}
        loading={loading}
        summaryRow={summary}
      />
    </Card>
  )
}
